import { jsx as n } from "react/jsx-runtime";
import b from "classnames";
import t from "./index.es679.js";
const h = "thumbnail-component", p = ({
  src: a,
  isLogo: l,
  size: i = "medium",
  testId: e = h,
  hasBackground: o,
  disabled: s,
  alt: u
}) => {
  let m = a;
  return typeof a == "string" && (m = /* @__PURE__ */ n("img", { src: a, alt: u || "Thumbnail image", className: t["thumbnail--image"] })), /* @__PURE__ */ n(
    "div",
    {
      className: b(t.thumbnail, t[`thumbnail--size-${i}`], {
        [t[`thumbnail--size-${i}-logo`]]: l,
        [t[`thumbnail--size-${i}-icon`]]: !l,
        [t.disabled]: s
      }),
      "data-type": "thumbnail",
      "data-testid": e,
      children: o ? /* @__PURE__ */ n("div", { className: t["thumbnail--background"], children: m }) : m
    }
  );
};
export {
  h as THUMBNAIL_DEFAULT_TESTID,
  p as Thumbnail
};
//# sourceMappingURL=index.es126.js.map
